import React from 'react'
import PropTypes from 'prop-types'
import {FormattedNumber} from 'react-intl'
import {useCurrency} from '../../../../hooks'

/**
 * PriceProduct component to display a formatted price.
 * @component
 * @param {Object} props - Component properties.
 * @param {number} props.value - The numeric value to format as a price.
 * @param {string} [props.currency] - The currency code (e.g., 'USD', 'EUR'). If not provided, defaults to the user's locale currency.
 * @returns {JSX.Element} Rendered CTA button element.
 */
const PriceProduct = ({value, currency}) => {
    const {currency: activeCurrency} = useCurrency()
    currency = currency || activeCurrency

    if (value == null) {
        return null
    }

    return <FormattedNumber value={value} currency={currency} style="currency" />
}

PriceProduct.propTypes = {
    value: PropTypes.number,
    currency: PropTypes.string
}

export default PriceProduct
